export class ApiEndPointsNotification {
    ConnectHub = 'api/CoreDocument/AddCoreDocumentFolder';
    NotificationList = "api/Notification/GetNotificationDetails";
    GetUnreadNotificationsCount = "api/Notification/GetUnreadNotificationsCount";
    MarkUnreadNotifications = "api/Notification/MarkUnreadNotifications";

    GetUsersListForChat = "api/ManageUser/GetUsersListForChat";
    getPortalEmailUserList = "api/ManageUser/getPortalEmailUserList";
    CreateChatRoom = "api/ChatRoom/CreateChatRoom";
    GetAllRoomsforUser = "api/ChatRoom/GetAllRoomsforUser";
    SearchChatOrMessages = "api/ChatRoom/SearchChatOrMessages";
    AddOrRemoveUserFromChatRoom = "api/ChatRoom/AddOrRemoveUserFromChatRoom";
    CreateChatMessage = "api/ChatRoom/CreateChatMessage";
    GetChatMessagesListForRoom = "api/ChatRoom/GetChatMessagesListForRoom";
    AddFileAsAttachment = "api/ChatRoom/UploadFileAttachment";
    GetAttachementsListForRoomId = "api/ChatRoom/GetAttachementsListForRoomId";
    getAttachment = 'api/App/DownloadDocument';
}
